import { render, staticRenderFns } from "./DialogGroupsAddEditGroup.vue?vue&type=template&id=e5f455d8"
import script from "./DialogGroupsAddEditGroup.vue?vue&type=script&lang=js"
export * from "./DialogGroupsAddEditGroup.vue?vue&type=script&lang=js"
import style0 from "./DialogGroupsAddEditGroup.vue?vue&type=style&index=0&id=e5f455d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports